import { getWidgetStores, InfoCard } from '@/entities/widget';
import CognitionIcon from '@/shared/assets/images/cognition.svg';
import { OptimizedImage } from '@/shared/ui/OptimizedImage/OptimizedImage';
import { DetailList } from '../DetailList/DetailList';
import { DetailStack } from '../DetailStack/DetailStack';
import { SectionTitle } from '../SectionTitle/SectionTitle';
import { DetailSection } from '../DetailSection/DetailSection';
import type { CreativeBriefSnapshotSectionProps } from './CreativeBriefSnapshotSection.types';
import { useTranslation } from 'react-i18next';

export function CreativeBriefSnapshotSection(props: CreativeBriefSnapshotSectionProps) {
  const { t } = useTranslation('contentTest');

  // ChatMarkdownRenderer via the entities/widget binding seam.
  const { ChatMarkdownRenderer } = getWidgetStores().chatStore;
  return (
    <div data-testid="social-brief-creative-brief-snapshot-section">
      <SectionTitle
        title={t('socialBriefWidget.creativeBriefSnapshotSection.creativeBriefSnapshot')}
        icon={
          <OptimizedImage
            src={CognitionIcon}
            alt={t('socialBriefWidget.creativeBriefSnapshotSection.cognitionIcon')}
          />
        }
        tooltip={t('socialBriefWidget.creativeBriefSnapshotSection.providesAQuickOverviewOf')}
      />
      <DetailSection>
        <DetailStack>
          <span className="text-body-lg font-medium text-foreground">
            {t('socialBriefWidget.creativeBriefSnapshotSection.suggestedMessagingStarters')}
          </span>

          <InfoCard style="w-full">
            <DetailList>
              {props.item.creativeBriefSnapshot.suggestedMessagingStarters.map((starter, index) => (
                <li key={index} className="text-body-lg text-foreground">
                  <ChatMarkdownRenderer content={starter} disableAnimation inline />
                </li>
              ))}
            </DetailList>
          </InfoCard>
        </DetailStack>
        <DetailStack>
          <span className="text-body-lg font-medium text-foreground">
            {t('socialBriefWidget.creativeBriefSnapshotSection.recommendedFormats')}
          </span>

          <InfoCard style="w-full">
            <DetailList>
              {props.item.creativeBriefSnapshot.recommendedFormats.map((format, index) => (
                <li key={index} className="text-body-lg text-foreground">
                  <ChatMarkdownRenderer content={format} disableAnimation inline />
                </li>
              ))}
            </DetailList>
          </InfoCard>
        </DetailStack>
        <DetailStack>
          <span className="text-body-lg font-medium text-foreground">
            {t('socialBriefWidget.creativeBriefSnapshotSection.referencesCitations')}
          </span>

          <InfoCard style="w-full">
            <DetailList>
              {props.item.creativeBriefSnapshot.references.map((ref, index) => (
                <li key={index} className="text-body-lg text-foreground">
                  <ChatMarkdownRenderer content={ref} disableAnimation inline />
                </li>
              ))}
            </DetailList>
          </InfoCard>
        </DetailStack>
      </DetailSection>
    </div>
  );
}
